import { IAddBankingRequest, IAddBankingResponse, ILoginResponse, ISignUPResponse, IUserProfileResponse } from '../../app/model/userModel';
import { API_ADD_BANK_DETAILS, API_GET_BANK_DETAILS_BY_ORG, API_LOGIN, API_SEND_LOGIN_OTP, API_SIGNUP, API_USER_PROFILE, API_VERIFY_LOGIN_OTP } from '../config';
import { apiClient } from '../HttpClient';

export async function signUpUser(userData: { email: string; first_name: string; last_name: string; role: string; password: string; phone_number: string; }): Promise<ISignUPResponse> {
  try {
    const client = await apiClient;
    const response = await client.post<ISignUPResponse>(API_SIGNUP, userData);
    return response;
  } catch (error: any) {
    const errorMessage = error?.status
    return errorMessage;
  }
}

export async function loginService(userData: { phone_number: string; password: string; }): Promise<ILoginResponse> {
  try {
    const client = await apiClient;
    const response = await client.post<ILoginResponse>(API_LOGIN, userData);
    return response;
  } catch (error: any) {
    const errorMessage = error?.status
    return errorMessage;
  }
}

export async function userProfileService(): Promise<IUserProfileResponse> {
  try {
    const client = await apiClient;
    const response = await client.get<IUserProfileResponse>(API_USER_PROFILE);
    return response;
  } catch (error: any) {
    const errorMessage = error?.status
    return errorMessage;
  }
}

export async function checkBankDetails(organizationId: string): Promise<boolean> {
  try {
    const client = await apiClient;
    await client.get(`${API_GET_BANK_DETAILS_BY_ORG}${organizationId}/`);
    return true;
  } catch {
    return false;
  }
}

export async function getBankDetails(organizationId: string): Promise<{ masked_account_number: string; ifsc_code: string } | null> {
  try {
    const client = await apiClient;
    const response = await client.get<{ masked_account_number: string; ifsc_code: string }>(`${API_GET_BANK_DETAILS_BY_ORG}${organizationId}/`);
    return response;
  } catch {
    return null;
  }
}

export async function addBankDetails(userData: IAddBankingRequest): Promise<IAddBankingResponse> {
  try {
    const client = await apiClient;
    const response = await client.post<IAddBankingResponse>(API_ADD_BANK_DETAILS, userData);
    return response;
  } catch (error: any) {
    const errorMessage = error?.status
    return errorMessage;
  }
}

export async function sendLoginOtpService(phone_number: string): Promise<{ message?: string; error?: string; dev_otp?: string }> {
  try {
    const client = await apiClient;
    const response = await client.post<{ message?: string; error?: string }>(API_SEND_LOGIN_OTP, { phone_number });
    return response;
  } catch (error: any) {
    return { error: error?.response?.data?.error || 'Failed to send OTP.' };
  }
}

export async function verifyLoginOtpService(phone_number: string, otp: string): Promise<ILoginResponse> {
  try {
    const client = await apiClient;
    const response = await client.post<ILoginResponse>(API_VERIFY_LOGIN_OTP, { phone_number, otp });
    return response;
  } catch (error: any) {
    return error?.status;
  }
}

